import { AbstractSearchCriteria } from './abstract-search-criteria';

export class LedgerAccountSearchCriteria extends AbstractSearchCriteria {
    code: string;
}